import { Component, OnInit } from '@angular/core';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ColumnApi, GridApi } from 'ag-grid-enterprise';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ETLDataFeedDependencies, ETLDataFeedDependency } from '../cxone-etl-data-feed.model';

@Component({
    selector: 'cv-cxone-etl-data-feed-dependencies',
    templateUrl: './cxone-etl-data-feed-dependencies.component.html',
    styleUrls: ['./cxone-etl-data-feed-dependencies.component.scss']
})
export class CxoneEtlDataFeedDependenciesComponent implements OnInit {
    public title: string;
    public deleteLabel: string;
    public cancelLabel: string;
    public allowClose: boolean;
    public dataFeedDependencyGridOptions: GridOptions;
    public dependencies: ETLDataFeedDependencies;
    public gridApi: GridApi;
    public gridColumnApi: ColumnApi;
    public deleteWarning: string;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private _dialogRef: DynamicDialogRef,
        private _dialogConfig: DynamicDialogConfig
    ) { }

    async ngOnInit() {
        await this.cvLocalizationService.GetSection('ETL_Data_Feed');
        this.setGridOptions();

        if(this._dialogConfig.data !== null) {
            this.title = this._dialogConfig.data.title;
            this.deleteLabel = this._dialogConfig.data.saveLabel;
            this.cancelLabel = this._dialogConfig.data.cancelLabel;
            this.allowClose = this._dialogConfig.data.allowClose;
            this.deleteWarning = this._dialogConfig.data.deleteWarning;
            this.dependencies = this._dialogConfig.data.dependencies;
        }
    }

    public formatDependencies(dataFeedDependencies: ETLDataFeedDependencies): ETLDataFeedDependency[] {
        const displayDependenciesArr: ETLDataFeedDependency[] = [];
        const baseFeedLabel = this.getLocalizationString("Base_Feed", "Base Feed");
        const joinLabel = this.getLocalizationString("Join", "Join");
        const reportingSetLabel = this.getLocalizationString("Reporting_Set", "Reporting Set");
        const metricsLabel = this.getLocalizationString("Metrics", "Metrics");
        dataFeedDependencies?.BaseFeeds?.forEach((val) => {
            displayDependenciesArr.push({ Type: reportingSetLabel, Name: `${val} (${baseFeedLabel})` });
        });
        dataFeedDependencies?.Joins?.forEach((val) => {
            displayDependenciesArr.push({ Type: reportingSetLabel, Name: `${val} (${joinLabel})` });
        });
        dataFeedDependencies?.MetricAbvs?.forEach((val) => {
            displayDependenciesArr.push({ Type: metricsLabel, Name: `${val}` });
        });
        return displayDependenciesArr;
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Data_Feed", key, defaultValue);
        return baseString;
    }

    onDismiss() {
        this._dialogRef.close();
    }

    onDelete() {
        this._dialogConfig.data.onDelete();
        this._dialogRef.close();
    }

    public setGridOptions() {
        this.dataFeedDependencyGridOptions = {
            columnDefs: [
                {
                    field: 'Type',
                    colId: 'Type',
                    headerName: this.getLocalizationString("Type", "Type"),
                    rowGroup: true,
                    hide: true,
                    resizable: true,
                    suppressSizeToFit: true
                },
                {
                    field: 'Name',
                    colId: 'Name',
                    headerName: this.getLocalizationString("Names", "Names"),
                    resizable: true
                }
            ],
            onGridReady: (event: GridReadyEvent) => this.onGridReady(event),
            autoGroupColumnDef: {
                headerName: 'Type',
                headerClass: "group-header-align",
                cellRendererParams: {
                    suppressCount: false
                },
                minWidth: 55 // Min width of 55, so resizing column to be very small will not allow the padding to overlap with neighbor columns
            },
            groupDefaultExpanded: 1,
            context: this,
            rowHeight: 36,
            headerHeight: 44,
            animateRows: true,
            scrollbarWidth: 8,
            icons: {
                groupContracted: `<div class="sortIcons">
                    <svg class="icon-10">
                        <use href="../App_Themes/CXone/icons/arrow-right.svg#arrow-right"></use>
                    </svg>
                </div>`,
                groupExpanded: `<div class="sortIcons">
                    <svg class="icon-10">
                        <use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use>
                    </svg>
                </div>`
            }
        };
    }

    public onGridReady(event) {
        this.gridApi = event.api;
        this.gridColumnApi = event.columnApi;
        this.gridApi.setGridOption('columnDefs', this.dataFeedDependencyGridOptions.columnDefs);
        this.gridApi.sizeColumnsToFit();
        this.gridApi.setGridOption('rowData', this.formatDependencies(this.dependencies));
    }
}
